import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'

export const Main = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  margin: '0',
  maxWidth: 'none!important'
}))
